<template>
	<div id="app">
		<MainMenu />

		<router-view></router-view>
		<Footer v-if="!$route.meta.hideFooter" />
	</div>
</template>

<script>
export default {
	name: 'htaukcio',
	metaInfo () {
		return {
			title: this.$t('HT Auction'),
			titleTemplate: '%s | ' + this.$t('HT Auction'),
			meta: [
				{ property: 'og:title', content: this.$t('HT Auction') },
				{ property: 'og:site_name', content: this.$t('HT Auction') },
				{ property: 'og:type', content:  'website' },
				{ name: 'description', content: this.$t('Online auction for old documents, photos, stamps, postcards, etc. Take a look around.') },
				{ name: 'robots', content: 'index, follow' },
			],
			htmlAttrs: {
				lang: this.$i18n.locale ? this.$i18n.locale : 'hu',
			},
			link: [
				{ rel: 'icon', type: 'image/png', href: '/static/favicon.png' }
			],
			bodyAttrs: {
				class: 'has-navbar-fixed-top',
			},
		}
	},

	data() {
		return {}
	},
	methods: {
		searchProduct() {
			this.$router.push('/search/' + this.searchString)
			this.searchString = ''
		},
	},
	watch: {
		$route() {
			this.$root.$emit('updateCart')
		},
	},
	mounted: function () {
		var _this = this
		_this.$i18n.locale = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'hu'
		console.log('APP-MOUNTED:', _this.$i18n.locale)
		//show logout notify
		if (localStorage.getItem('logout') && localStorage.getItem('logout') == 'true') {
			localStorage.setItem('logout', null)
			_this.$buefy.snackbar.open({
				message: _this.$t('Successful logout'),
				position: 'is-top',
			})
		}
		this.$http
			.post('/users/renew')
			.then((response) => {
				_this.$http.defaults.headers.Authorization = response.data.token
				localStorage.setItem('token', response.data.token)
				_this.$store.commit('setToken', response.data.token)
				_this.$store.commit('setLoggedIn', true)
				console.log('Token renew success')
			})
			.catch((error) => {
				console.log(error)
			})
		this.$checkLoggedIn(this, (err, data) => {
			console.log('CHECK_LOGGED_IN:', err, data)
		})
		this.$socket.emit('getCurrencies', function (currencies) {
			console.log('currencies', currencies)
			_this.$store.commit('setCurrencies', currencies)
		})
	},
	computed: {
		dataAvailable() {
			return this.searchString !== null && this.searchString !== ''
		},
	},
	sockets: {
		authError(data) {
			console.log(data)
			this.$store.commit('setToken', null)
			this.$store.commit('setLoggedIn', false)
			localStorage.setItem('token', null)
		},
		tokenWarning() {
			var _this = this
			this.$http
				.post('/users/renew')
				.then((response) => {
					_this.$http.defaults.headers.Authorization = response.data.token
					localStorage.setItem('token', response.data.token)
					_this.$store.commit('setToken', response.data.token)
					_this.$store.commit('setLoggedIn', true)
					console.log('Token renew success')
				})
				.catch((error) => {
					console.log(error)
				})
		},
	},
}
</script>
